export enum RolesEnum {
  ADMIN = 'ADMIN'
}
